"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PathStep;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _context = require("../Path/context");

var _helpers = require("./helpers");

var _styled = require("./styled");

var _checkMark = _interopRequireDefault(require("./icons/checkMark"));

var _exclamation = _interopRequireDefault(require("./icons/exclamation"));
/**
 * The PathStep component displays progress through a sequence of
 * logical and numbered steps. Path and PathStep components are
 * related and should be implemented together.
 */


function PathStep(props) {
  var name = props.name,
      label = props.label,
      hasError = props.hasError,
      className = props.className,
      style = props.style;

  var _useContext = (0, _react.useContext)(_context.PathContext),
      selectedIndex = _useContext.selectedIndex,
      hoveredIndex = _useContext.hoveredIndex,
      privateGetStepIndex = _useContext.privateGetStepIndex,
      privateGetStepZIndex = _useContext.privateGetStepZIndex,
      privateRegisterStep = _useContext.privateRegisterStep,
      privateUnregisterStep = _useContext.privateUnregisterStep,
      privateUpdateStepProps = _useContext.privateUpdateStepProps,
      privateUpdateHoveredStep = _useContext.privateUpdateHoveredStep,
      privateOnClick = _useContext.privateOnClick;

  var stepRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    privateRegisterStep(stepRef.current, {
      name: name,
      label: label,
      hasError: hasError
    });
    return function () {
      privateUnregisterStep(stepRef, name);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    privateUpdateStepProps({
      name: name,
      label: label,
      hasError: hasError
    });
  }, [name, label, hasError, privateUpdateStepProps]);
  var index = privateGetStepIndex(name);
  var activeStepIndex = (0, _react.useMemo)(function () {
    return (0, _helpers.getActiveStepIndex)({
      hoveredIndex: hoveredIndex,
      selectedIndex: selectedIndex
    });
  }, [hoveredIndex, selectedIndex]);
  var isChecked = activeStepIndex > index;
  var isSelected = (0, _react.useMemo)(function () {
    return (0, _helpers.isStepSelected)({
      index: index,
      hoveredIndex: hoveredIndex,
      selectedIndex: selectedIndex
    });
  }, [hoveredIndex, index, selectedIndex]);
  var renderCheckIcon = !hasError && (isChecked || isSelected || activeStepIndex === index);
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledStepItem, {
    ref: stepRef,
    role: "option",
    className: className,
    style: style,
    isSelected: isSelected,
    hasError: hasError,
    isChecked: isChecked,
    zIndex: privateGetStepZIndex(name),
    onClick: function onClick() {
      return privateOnClick(name);
    },
    onMouseEnter: function onMouseEnter() {
      return privateUpdateHoveredStep(name);
    },
    onMouseLeave: function onMouseLeave() {
      return privateUpdateHoveredStep(null);
    }
  }, label, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: renderCheckIcon
  }, /*#__PURE__*/_react["default"].createElement(_checkMark["default"], null)), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: hasError
  }, /*#__PURE__*/_react["default"].createElement(_exclamation["default"], null)));
}

PathStep.propTypes = {
  /** The name of the PathStep. */
  name: _propTypes["default"].string.isRequired,

  /** The label of the PathStep. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Boolean indicating whether the PathStep has error. */
  hasError: _propTypes["default"].bool,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
PathStep.defaultProps = {
  label: undefined,
  hasError: false,
  className: undefined,
  style: undefined
};